import type { StudentAccessibilityPreferences } from "@wmf/shared/studentAccessibility";
import { get, send } from "./api.js";

export type { StudentAccessibilityPreferences } from "@wmf/shared/studentAccessibility";
export {
  DEFAULT_STUDENT_ACCESSIBILITY_PREFERENCES,
  STUDENT_ACCESSIBILITY_FONT_FAMILIES,
  STUDENT_ACCESSIBILITY_FONT_SIZES,
  STUDENT_ACCESSIBILITY_TEXT_SPACING,
} from "@wmf/shared/studentAccessibility";

export interface StudentAccessibilityPreferencesResponse {
  preferences: StudentAccessibilityPreferences;
}

/** Read the selected student's persisted presentation choices. */
export function getStudentAccessibilityPreferences(
  studentId: string,
): Promise<StudentAccessibilityPreferencesResponse> {
  return get(`/me/students/${encodeURIComponent(studentId)}/accessibility`);
}

/** Replace the selected student's complete presentation preference object. */
export function saveStudentAccessibilityPreferences(
  studentId: string,
  preferences: StudentAccessibilityPreferences,
): Promise<StudentAccessibilityPreferencesResponse> {
  return send(
    "PUT",
    `/me/students/${encodeURIComponent(studentId)}/accessibility`,
    preferences,
  );
}

/** Remove the stored row so the student follows the Hub's current defaults again. */
export function resetStudentAccessibilityPreferences(
  studentId: string,
): Promise<StudentAccessibilityPreferencesResponse> {
  return send("DELETE", `/me/students/${encodeURIComponent(studentId)}/accessibility`);
}
